<template>
  <div class="newsearch">
    <div class="newsearch-header">
      <h3>学科关键词分析</h3>
      <form-list
        :classes="'search-form search-form-center'"
        :rules="rules"
        refer="formSearch"
        :model="formResource"
        :formList="searchList"
        @submit="editSumbit"
        :labelWidth="'130px'"
        :inline="true"
      ></form-list>
    </div>
    <div class="newsearch-main">
      <div class="newsearch-main-tab1" v-loading="tab0.loading">
        <h3>
          高频关键词分析
          <el-button @click="showDetail(1)" slot="upload" type="primary" size="small">导出</el-button>
        </h3>
        <el-table :data="tab0.list" stripe highlight-current-row style="width: 100%">
          <el-table-column
            :prop="item.prop"
            :type="item.type"
            :align="item.align"
            :formatter="item.formatter"
            v-for="(item, index) in tab0.cloumns"
            :key="'table'+index"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'keyword'">
                <span
                  :class="[formResource.keyword == scope.row[item.prop] ?'red':'','cup']"
                  @click="handleCurrentChange(scope.row)"
                >{{scope.row[item.prop]}}</span>
              </div>
              <div
                v-else
                class="cell"
              >{{scope.row.formatter?scope.row.formatter:scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :hide-on-single-page="true"
          :total="tab0.pageData.total"
          :page.sync="tab0.pagetion.page"
          :limit.sync="tab0.pagetion.pageSize"
          :layout="tab0.pageData.layout"
          :pageCount="5"
          @pagination="getPage1"
        />
      </div>
      <div class="newsearch-main-tab2" v-loading="tab1.loading">
        <h3>
          关键词词对
          <el-button slot="upload" type="primary" @click="showDetail(2)" size="small">导出</el-button>
        </h3>
        <el-form label-width="140px">
          <el-form-item label="次对关键词数量选择">
            <el-checkbox v-model="tab1.length.check1">2关键词词对</el-checkbox>
            <el-checkbox v-model="tab1.length.check2">3关键词词对</el-checkbox>
          </el-form-item>
        </el-form>
        <el-table :data="tab1.list" stripe highlight-current-row style="width: 100%">
          <el-table-column
            :prop="item.prop"
            :type="item.type"
            :align="item.align"
            :formatter="item.formatter"
            v-for="(item, index) in tab1.cloumns"
            :key="'table'+index"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'pairData'">
                <span
                  :class="[formResource.keyword == el ?'red':'','cup',ciduiKey == el?'activeted':'']"
                  @click="searchOne(el)"
                  v-for="(el,i) in scope.row.pairDataArr"
                  :key="i"
                >{{i== scope.row.pairDataArr.length -1 ?el:el+'-'}}</span>
              </div>
              <div
                v-else
                class="cell"
              >{{scope.row.formatter?scope.row.formatter:scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :hide-on-single-page="true"
          :total="tab1.pageData.total"
          :page.sync="tab1.pagetion.page"
          :limit.sync="tab1.pagetion.pageSize"
          :layout="tab1.pageData.layout"
          :pageCount="5"
          @pagination="getPage2"
        />
      </div>
      <div class="newsearch-main-charts">
        <h3>
          联想关键词关系图
          <el-button @click="showGraph()" slot="upload" type="primary" size="small">放大</el-button>
        </h3>
        <el-form label-width="120px">
          <el-form-item label="数量限制">
            <el-select v-model="countList.value" placeholder="请选择">
              <el-option
                v-for="item in countList.list"
                :key="item.value"
                :label="item.label"
                :value="item.value*1"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <GraphChart
          v-loading="cooChart.loading"
          :list="cooChart.list"
          @search="editSumbit"
          class="area"
          id="graphChart"
          height="500px"
          width="600px"
        />
      </div>
    </div>
    <el-dialog
      :title="dialogObj.title"
      :width="'100%'"
      top="0vh"
      :fullscreen="true"
      :close-on-click-modal="false"
      :visible.sync="dialogObj.show"
    >
      <div class="search-excel">
        <form-list
          :rules="rules"
          refer="formSearchExcel"
          :model="dialogObj.formResource"
          :formList="dialogObj.searchList"
          @submit="dialogBtn"
          :inline="true"
        ></form-list>
      </div>
      <div class="data-title-tips" v-if="dialogObj.type == 2 && twoAndThree">
        <div>
          <div>2关键词词对</div>
        </div>
        <div>
          <div>3关键词次词对</div>
        </div>
      </div>
      <div class="data-title">
        <div v-if="dialogObj.list.length>0">
          <span>关键词(频次)</span>
          <!-- <span>频次</span> -->
        </div>
        <div v-if="dialogObj.list.length>1">
          <span>关键词(频次)</span>
          <!-- <span>频次</span> -->
        </div>
        <div v-if="dialogObj.list.length>2">
          <span>关键词(频次)</span>
          <!-- <span>频次</span> -->
        </div>
        <div v-if="dialogObj.list.length>3">
          <span>关键词(频次)</span>
          <!-- <span>频次</span> -->
        </div>
        <div v-if="dialogObj.list.length>4 || dialogObj.list1.length">
          <span>关键词(频次)</span>
          <!-- <span>频次</span> -->
        </div>
      </div>
      <el-carousel height="600px" direction="vertical" :autoplay="false">
        <el-carousel-item v-for="(p,k) in dialogObj.swiperLength" :key="k">
          <el-scrollbar class="infinite-list" v-loading="dialogObj.loading">
            <div :class="['data-list',dialogObj.list1.length ? 'data-list-two' : '']">
              <div
                v-for="(item, index) in dialogObj.list"
                v-if="index >= (k)*dialogObj.swiperItemCount &&  index < (k+1)*dialogObj.swiperItemCount"
                :key="index"
              >
                <span
                  v-if="item.keyword"
                  :class="[formResource.keyword == item.keyword?'red':'']"
                >{{item.keyword}}({{item.count}})</span>

                <span v-if="item.pairData">
                  <em
                    :class="[formResource.keyword == el ?'red':'',ciduiKey == el?'activeted':'']"
                    v-for="(el,i) in item.pairDataArr"
                    :key="i"
                  >{{i== item.pairDataArr.length -1 ?el:el+'-'}}</em>
                  ({{item.count}})
                </span>
                <!-- <span>{{item.count}}</span> -->
              </div>
            </div>

            <div
              v-if="dialogObj.list1.length"
              :class="['data-list',twoAndThree ? 'data-list-three' : '']"
            >
              <div
                v-for="(item, index) in dialogObj.list1"
                v-if="index >= (k)*dialogObj.swiperItemCount &&  index < (k+1)*dialogObj.swiperItemCount"
                :key="index"
              >
                <span
                  v-if="item.keyword"
                  :class="[formResource.keyword == item.keyword?'red':'']"
                >{{item.keyword}}({{item.count}})</span>

                <span v-if="item.pairData">
                  <em
                    :class="[formResource.keyword == el ?'red':'',ciduiKey == el?'activeted':'']"
                    v-for="(el,i) in item.pairDataArr"
                    :key="i"
                  >{{i== item.pairDataArr.length -1 ?el:el+'-'}}</em>
                  ({{item.count}})
                </span>
                <!-- <span>{{item.count}}</span> -->
              </div>
            </div>
          </el-scrollbar>
        </el-carousel-item>
      </el-carousel>

      <!-- <el-scrollbar v-loading="dialogObj.loading" class="infinite-list" v-infinite-scroll="load">

        
      </el-scrollbar>-->
    </el-dialog>
    <el-dialog
      :title="wordDialog.title"
      :width="'70%'"
      top="5vh"
      :close-on-click-modal="false"
      :visible.sync="wordDialog.show"
    >
      <wordcloud-Chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        :WordCloudList="wordDialog.list"
        :max="wordDialog.max"
        id="CNChart"
        height="500px"
        width="100%"
        tit
        :isClick="wordDialog.isClick"
      />
    </el-dialog>
    <el-dialog
      title="联想关键词关系图"
      :width="'70%'"
      top="5vh"
      :fullscreen="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :visible.sync="graphDialog.show"
    >
      <GraphChart
        :list="cooChart.list2"
        @search="editSumbit"
        class="graphCharts"
        ref="graphCharts"
        height="800px"
        width="100%"
      />
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import FormList from "@/components/FormList";
import Pagination from "@/components/Pagination";
import GraphChart from "@/components/Charts/GraphChart";
import WordcloudChart from "@/components/Charts/WordcloudChart";
import {
  searchCoreKeywordsv2,
  expertExcel,
  searchCoreKeywordsv3,
  expertSubject
} from "@/api/newsearch";
export default {
  name: "newsearch",
  components: {
    Pagination,
    FormList,
    GraphChart,
    WordcloudChart
  },
  data() {
    return {
      searchList: [
        {
          label: "学科选择：",
          tag: "subjectValue",
          value: 1,
          type: "select",
          options: [
            { label: "图书与情报科学", value: 1 },
            { label: "宗教", value: 2 }
          ],
          prop: "name",
          index: 0,
          placeholder: "请选择学科"
        },
        {
          label: "关键词词频限制：",
          tag: "count",
          value: 10,
          type: "select",
          options: [
            { label: "10次", value: 10 },
            { label: "5次", value: 5 },
            { label: "3次", value: 3 },
            { label: "1次", value: 1 }
          ],
          index: 1,
          placeholder: "请选择词频"
        },
        {
          label: "词对词频限制：",
          tag: "count1",
          value: 10,
          type: "select",
          options: [
            { label: "10次", value: 10 },
            { label: "5次", value: 5 },
            { label: "3次", value: 3 },
            { label: "1次", value: 1 }
          ],
          index: 2,
          placeholder: "请选择词频"
        },
        { type: "kong", classes: "item-block" },
        {
          label: "关键词搜索：",
          tag: "keyword",
          value: "",
          type: "input",
          prop: "keyword",
          index: 3,
          placeholder: "请输入关键词搜索",
          classes: "w500"
        },
        { label: "检索", value: "", type: "button", index: 4, loading: false }
      ],
      rules: {
        keyword: [{ min: 2, message: "至少两个字符", trigger: "blur" }]
      },
      formResource: {}, //表单数据
      tab0: {
        loading: false,
        list: [],
        cloumns: [
          { prop: "keyword", label: "关键词", align: "center" },
          { prop: "count", label: "频次", align: "center", width: 80 }
        ],
        pageData: {
          layout: " prev, pager, next",
          total: 0,
          pageSizes: [10, 20, 50] // 每页数量
        },
        pagetion: {
          page: 1,
          pageSize: 10
        }
      },
      tab1: {
        loading: false,
        length: {
          check1: true,
          check2: true
        },
        list: [],
        cloumns: [
          { prop: "pairData", label: "关键词词对", align: "center" },
          { prop: "count", label: "频次", align: "center", width: 80 }
        ],
        pageData: {
          layout: " prev, pager, next",
          total: 0,
          pageSizes: [10, 20, 50] // 每页数量
        },
        pagetion: {
          page: 1,
          pageSize: 10
        }
      },
      kId: "1723658437",
      cooChart: {
        //合作学者
        loading: false,
        list2: {
          data: [],
          links: [],
          repulsion: 400,
          categories: []
        },
        list: {
          data: [],
          links: [],
          categories: []
        }
      },
      countList: {
        loading: false,
        value: 30,
        list: [
          { label: "15", value: 15 },
          { label: "30", value: 30 },
          { label: "50", value: 50 },
          { label: "100", value: 100 }
        ]
      },
      formResourceClone: {
        subject: ""
      },
      params: {},
      currentRow: {},
      ciduiKey: "",
      dialogObj: {
        title: "关键词概况",
        show: false,
        loading: false,
        type: 1,
        list: [],
        list1: [],
        swiperLength: 1, //走马灯的长度
        swiperItemCount: 80,
        formResource: {
          pageSize: 300,
          pageSizeThree: 0
        },
        ajax: 1,
        searchList: [
          {
            label: "行数限制：",
            tag: "pageSize",
            value: "",
            type: "input",
            options: [
              { label: "500", value: 500 },
              { label: "100", value: 100 }
            ],
            index: 0,
            placeholder: "请输入行数"
          },

          {
            label: "查询",
            value: "",
            type: "button",
            types: "primary",
            index: 1,
            loading: false
          },
          {
            label: "生成词云",
            types: "error",
            value: "",
            types: "success",
            type: "button",
            index: 2,
            loading: false
          },
          {
            label: "导出",
            types: "danger",
            value: "",
            type: "button",
            index: 3,
            loading: false
          }
        ]
      },
      wordDialog: {
        show: false,
        title: "",
        list: [],
        max: 100,
        isClick: false
      },
      graphDialog: {
        show: false,
        loading: false,
        title: ""
      },
      changeSubject: false
    };
  },
  computed: {
    formResourceCpt() {
      return this.formResource.subjectValue;
    },
    tab1Length() {
      return this.tab1.length;
    },
    twoAndThree() {
      let check1 = this.tab1Length.check1;
      let flag = check1 && this.tab1Length.check2 && true ? true : false;
      return flag;
    }
  },
  watch: {
    twoAndThree: {
      deep: true,
      handler(val) {
        if (val) {
        }
      }
    },
    formResourceCpt: {
      deep: true,
      handler(val) {
        if (val) {
          this.changeSubject = true;
          this.expertKeyword().then(res => {
            this.keywordPair();
          });
        }
      }
    },
    tab1Length: {
      deep: true,
      handler(val) {
        if (val) {
          this.keywordPair();
        }
      }
    }
  },
  async mounted() {
    var obj = {};
    await this.expertSubject();
    this.searchList.map(item => {
      if (item.type == "input") {
        obj[item.tag] = item.value;
      } else if (item.type == "select") {
        obj[item.tag] = item.value;
      }
    });
    this.formResource = obj;
    // this.editSumbit();
  },
  methods: {
    async expertSubject() {
      await expertSubject().then(res => {
        console.log(res);
        if (res.code == 200) {
          let options = [];
          res.data.map(item => {
            item.label = item.subject;
            item.value = item.id;
          });
          this.searchList[0].options = res.data;
        }
      });
    },
    showWord() {
      if (!this.dialogObj.list.length) return;
      this.wordDialog.show = true;
      this.wordDialog.title = this.formResource.keyword;
      this.wordDialog.list = [];
      this.wordDialog.max = this.dialogObj.formResource.pageSize * 1;
      let list = [];
      this.dialogObj.list.map((item, index) => {
        let temp = {
          name: (item.pairData || item.keyword) + "(" + item.count + ")",
          count: item.count
        };
        list.push(temp);
      });
      this.wordDialog.list = list;
    },
    load() {},
    showGraph() {
      this.graphDialog.show = true;
      this.$nextTick(() => {
        // 渲染chart
        let symbolSize = this.countList.value > 50 ? 100 : 200;
        let list2 = JSON.parse(JSON.stringify(this.cooChart.list));
        list2.data.map(item => {
          item.symbolSize =
            item.symbolSize * 3 > symbolSize ? symbolSize : item.symbolSize * 3;
          item.fontSize = 20;
        });
        list2.repulsion = 800;
        this.cooChart.list2 = list2;

        // this.$refs.graphCharts.setInit();
      });
    },
    showDetail(type) {
      this.dialogObj.title = "关键词概况-" + this.formResource.keyword;
      this.dialogObj.show = true;
      this.dialogObj.loading = true;
      this.dialogObj.list = [];
      this.dialogObj.list1 = [];
      this.dialogObj.type = type;
      if (type == 1) {
        this.expertKeyword(true);
      } else if (type == 2) {
        this.dialogObj.ajax = 1;
        this.keywordPair(true).then(res => {
          this.dialogObj.ajax = 2;
          this.keywordPair(true);
        });
      } else if (type == 3) {
      }
    },
    dialogBtn(item) {
      if (item.label == "查询") {
        if (this.dialogObj.type == 1) {
          this.expertKeyword(true);
        } else if (this.dialogObj.type == 2) {
          this.keywordPair(true);
        }
      } else if (item.label == "生成词云") {
        this.showWord();
      } else {
        //导出
        let params = this.params;
        let tab1Length = this.tab1Length;
        let check1 = this.tab1Length.check1,
          check2 = this.tab1Length.check2;
        if (check1 || check2) {
          params.length = check1 ? (check2 ? "2,3" : 2) : 3;
        } else {
          params.length = 2;
        }
        params.pageSize = this.dialogObj.formResource.pageSize;
        if (this.dialogObj.type == 1) {
          params.type = "keywords";
        } else if (this.dialogObj.type == 2) {
          params.type = "pairs";
        }
        let str = this.objToStr(params);
        this.searchExcel(params, str);
      }
    },
    objToStr(params = {}) {
      let str = "";
      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const element = params[key];
          str += key + "=" + element + "&";
        }
      }
      return str;
    },
    searchExcel(params, str) {
      window.open("http://183.136.237.195/old/expert/excel?" + str);
      //   request({
      //     data: params,
      //     url: "/old/expert/excel?" + str,
      //     method: "GET"
      //   });
    },
    searchOne(keyword) {
      this.ciduiKey = keyword;
      this.searchCoreKeywordsv2(keyword);
    },
    handleCurrentChange(row) {
      this.currentRow = row;
      this.formResource.keyword = row.keyword;
      this.searchCoreKeywordsv2();
      this.keywordPair();
    },
    editSumbit(keyword = {}) {
      if (keyword.typeof === "String") {
        if (keyword == this.formResource.keyword) return;
        this.formResource.keyword = keyword;
      }

      if (this.formResource.keyword) {
        this.searchCoreKeywordsv2();
      }
      this.keywordPair();
      this.expertKeyword();
    },
    getPage1(
      obj = {
        page: this.tab0.pagetion.page,
        pageSize: this.tab0.pagetion.pageSize
      }
    ) {
      this.tab0.pagetion.page = obj.limit ? 1 : obj.page || 1;
      this.tab0.pagetion.pageSize = obj.limit || this.tab0.pagetion.pageSize;
      this.expertKeyword();
    },
    getPage2(
      obj = {
        page: this.tab1.pagetion.page,
        pageSize: this.tab1.pagetion.pageSize
      }
    ) {
      this.tab1.pagetion.page = obj.limit ? 1 : obj.page || 1;
      this.tab1.pagetion.pageSize = obj.limit || this.tab1.pagetion.pageSize;
      this.keywordPair();
    },
    getParams() {
      let params = this.formResource;
      params.subject = "";
      let _this = this;
      this.searchList[0].options.some(item => {
        if (item.value == _this.formResource.subjectValue) {
          params.subject = item.label;
          return true;
        }
      });
      return params;
    },
    expertKeyword(dialog) {
      let { page, count1, ...params } = {
        ...this.getParams(),
        ...this.tab0.pagetion
      };
      params.pageNum = page;
      if (dialog) {
        params.pageNum = 1;
        this.dialogObj.loading = true;
        params.pageSize = this.dialogObj.formResource.pageSize;
      }
      let str = this.objToStr(params);

      this.tab0.loading = !dialog ? true : false;
      this.params = params;
      return new Promise(resolve => {
        request({
          data: params,
          url: "/old/expert/keyword?" + str,
          method: "GET"
        }).then(res => {
          this.tab0.loading = false;
          this.dialogObj.loading = false;
          if (res.success) {
            if (
              (!this.formResource.keyword && !this.tab0.list.length) ||
              this.changeSubject
            ) {
              this.changeSubject = false;
              this.formResource.keyword = res.data[0].keyword;
              this.searchCoreKeywordsv2();
            }
            if (!dialog) {
              this.tab0.list = res.data;
              this.tab0.pageData.total = res.count;
            } else {
              this.dialogObj.swiperLength = Math.ceil(res.data.length / 100);
              this.dialogObj.list = res.data;
            }
            resolve();
          }
        });
      });
    },
    keywordPair(dialog) {
      let { page, count, count1, ...params } = {
        ...this.getParams(),
        ...this.tab1.pagetion,
        length: ""
      };
      params.pageNum = page;
      params.count = count1;
      let check1 = this.tab1.length.check1,
        check2 = this.tab1.length.check2;
      if (check1 || check2) {
        params.length = check1 ? (check2 ? "2,3" : 2) : 3;
      } else {
        params.length = 2;
      }
      if (dialog) {
        // TODO 在这里要判断 params.length
        params.pageNum = 1;
        this.dialogObj.loading = true;
        params.pageSize = this.dialogObj.formResource.pageSize;
        if (this.twoAndThree) {
          // 2并且3的情况才进这里
          if (this.dialogObj.ajax == 1) {
            params.length = 2;
            params.pageSize = parseInt(
              this.dialogObj.formResource.pageSize * 0.8
            );
          } else if (this.dialogObj.ajax == 2) {
            params.length = 3;
            params.pageSize = parseInt(
              this.dialogObj.formResource.pageSize / 5
            );
          }
        }
      }
      let str = this.objToStr(params);

      this.tab1.loading = !dialog ? true : false;
      this.params = params;
      return new Promise(resolve => {
        request({
          data: params,
          url: "/old/expert/keywordPair?" + str,
          method: "GET"
        }).then(res => {
          this.tab1.loading = false;
          this.dialogObj.loading = false;
          if (res.success) {
            res.data.map(item => {
              item.pairDataArr = item.pairData.split("-");
            });
            if (!dialog) {
              this.tab1.list = res.data;
              this.tab1.pageData.total = res.count;
            } else {
              if (this.twoAndThree && this.dialogObj.ajax == 2) {
                this.dialogObj.list1 = res.data;
              } else {
                this.dialogObj.list = res.data;
              }
              let len1 =
                this.dialogObj.list.length / this.dialogObj.swiperItemCount;
              let len2 = this.dialogObj.list1.length / 20;
              this.dialogObj.swiperLength = Math.ceil(
                len1 > len2 ? len1 : len2
              );
            }
          }
          resolve();
        });
      });
    },
    searchCoreKeywordsv2(keyword) {
      this.cooChart.loading = true;
      searchCoreKeywordsv3({
        keyword: keyword || this.formResource.keyword,
        subject: this.formResource.subject,
        pageSize: this.countList.value
      }).then(res => {
        if (res.data.result) {
          let datas = res.data.data.cnkeyword;
          let links = [],
            data = [],
            total = 0,
            user = {},
            symbolList = {
              "0": {
                normal:
                  "image://http://183.136.237.195/static/images/layout/zm.png",
                selected:
                  "image://http://183.136.237.195/static/images/layout/zm1.png"
              },
              "1": {
                normal:
                  "image://http://183.136.237.195/static/images/layout/hz.png",
                selected:
                  "image://http://183.136.237.195/static/images/layout/hz1.png"
              }
            },
            basicSymbolSize = 40,
            len = this.countList.value,
            repulsion = 100;
          switch (true) {
            case len == 15:
              basicSymbolSize = 60;
              repulsion = 200;
              break;
            case len == 30:
              basicSymbolSize = 50;
              repulsion = 220;
              break;
            case len == 50:
              basicSymbolSize = 40;
              repulsion = 240;
              break;
            case len == 100:
              basicSymbolSize = 35;
              repulsion = 260;
              break;
            default:
              break;
          }
          // http://183.136.237.195/static/images/layout/honor2.png
          datas.map((item, i) => {
            total += item.doc_count;
            item.status = item.status == 1 ? 0 : 1;
            // + item.doc_count
            data.push({
              id: i + "",
              name: item.key,
              symbolSize: item.doc_count / 2 > 100 ? 100 : item.doc_count / 2,
              value: item.doc_count,
              symbol: symbolList[item.status].normal,
              symbolTrue: symbolList[item.status].selected,
              border: item.status == 0 ? true : false,
              // x: -53.365552,
              // y: 59.93808,
              kId: item.kId,
              fontSize: item.doc_count > 20 ? 14 : 12
            });

            links.push({
              id: i + "",
              source: i + "",
              target: "-1",
              name: item.key,
              value: item.doc_count,
              border: false
            });
          });
          data.unshift({
            id: "-1",
            name: keyword || this.formResource.keyword,
            value: "",
            fontColor: "#fff",
            fontSize: 16,
            symbol:
              "image://http://183.136.237.195/static/images/layout/all.png",
            symbolTrue:
              "image://http://183.136.237.195/static/images/layout/all.png",
            status: -1,
            symbolSize: 100,
            category: 0,
            categoryName: ""
          });
          let obj = {
            data,
            links,
            symbolList,
            total,
            user,
            repulsion
          };
          console.log(obj);
          this.cooChart.list = obj;
          setTimeout(() => {
            this.cooChart.loading = false;
          }, 1000);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.newsearch {
  h3 {
    text-align: center;
    margin-bottom: 20px;
    position: relative;
    button {
      padding: 4px 10px;
      position: absolute;
      right: 0;
      top: 10px;
    }
  }
  min-height: 500px;
  margin-top: 20px;
  &-header {
    width: 1080px;
    margin: 0 auto;
  }
  &-main {
    display: flex;
    justify-content: center;
    > div {
      padding: 0 30px;
    }
    &-tab1 {
      //   min-width: 400px;
      .el-table {
        margin-top: 60px;
      }
    }
    &-tab2 {
      //   min-width: 400px;
    }
    &-charts {
      //   width: 500px;
    }
  }
}
.el-table__row {
  cursor: pointer;
}
.red {
  color: red;
}
.cup {
  cursor: pointer;
}

.activeted,
.cup:hover {
  color: #409eff;
}
.search-excel {
  text-align: center;
  position: relative;
}

.data-title,
.data-list,
.data-title-tips {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  font-size: 20px;
  > div {
    width: 20%;
    padding-right: 20px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    > span {
      width: 100%;
      border: 1px solid #999;
    }
    span:nth-child(2n) {
      border-left: none;
    }
    span:nth-child(2n + 1) {
    }
  }
}
.data-title-tips {
  color: red;
  > div {
    justify-content: center;
  }
  > div:first-child {
    width: 80%;
    div {
      width: 100%;
      background: #eee;
    }
    text-align: center;
  }
  > div:last-child {
    width: 20%;
    div {
      width: 100%;
      background: #eee;
    }
  }
}
.data-list-two {
  width: 80%;
  > div {
    width: 25%;
  }
}
.data-list-three {
  width: 20%;
  > div {
    width: 100%;
  }
}
.data-title {
  > div {
    span {
      background: #eee;
    }
  }
}
.data-list {
  > div {
    margin-top: -1px;
  }
  em {
    font-style: normal;
  }
}

.infinite-list {
  height: 700px;
  overflow-y: auto;
  overflow-x: hidden;
  >>> .el-scrollbar__view {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
}
body {
  .el-carousel {
    // background: #000;
    >>> .el-carousel__indicators {
    }
    >>> .el-carousel__button {
      background-color: #000;
    }
    >>> .el-carousel__item {
    }
  }
  >>> .el-carousel__indicators--vertical {
    background: #000;
    .el-carousel__indicator {
      background: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newsearch/newsearch.vue